export default class Prepress {
  index() {}
}
